//Debounce function for performance when resize
//Kicks in when user stops or starts (immediate)
const wpk_debounce = (func, wait, immediate=false) => {
    let timeout;
    return function (...args) {
        const later = () => {
            timeout = null;
            if (!immediate) func.apply(this, args);
        };
        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(this, args);
    };
};
/*
//Usage
//Listen to the window resize event (with debounce function for performance)
window.addEventListener('resize', wpk_debounce(function () {
    console.log('debounce');
}, 500, true));
*/


//Throttle function for performance when scroll
//Kicks in every * 
const wpk_throttle = (func, limit) => {
    let lastFunc
    let lastRan
    return function() {
        const context = this
        const args = arguments
        if (!lastRan) {
        func.apply(context, args)
        lastRan = Date.now()
        } else {
        clearTimeout(lastFunc)
        lastFunc = setTimeout(function() {
            if ((Date.now() - lastRan) >= limit) {
            func.apply(context, args)
            lastRan = Date.now()
            }
        }, limit - (Date.now() - lastRan))
        }
    }
}
/*
//Usage
//Listen to the window scroll event (with debounce function for performance)
window.addEventListener('scroll', wpk_throttle(function () {
    console.log('throttle');
}, 500));
*/